var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoF1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "649.000000pt",
    height: "897.000000pt",
    viewBox: "0 0 649.000000 897.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,897.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1050 4130 l0 -3910 875 0 875 0 0 1570 0 1570 1520 0 1520 0 0 605 0 605 -1520 0 -1520 0 0 1030 0 1030 1845 0 1845 0 0 705 0 705 -2720 0 -2720 0 0 -3910z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoF1);
export default __webpack_public_path__ + "static/media/logo-f1.3fc59817b62ffb62e8518ca789a888fe.svg";
export { ForwardRef as ReactComponent };